import { collection, addDoc, query, where, orderBy, limit, getDocs, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export const AUDIT_EVENTS = {
  SIGN_IN:         'sign_in',
  SIGN_OUT:        'sign_out',
  SIGN_UP:         'sign_up',
  DECK_CREATED:    'deck_created',
  DECK_DELETED:    'deck_deleted',
  SESSION_STARTED: 'session_started',
  SESSION_SAVED:   'session_saved',
  IMAGE_UPLOADED:  'image_uploaded',
  PROFILE_UPDATED: 'profile_updated',
};

export const logAuditEvent = async (userId, event, metadata = {}) => {
  if (!userId) return;
  try {
    await addDoc(collection(db, 'auditLogs'), {
      userId,
      event,
      metadata,
      timestamp: serverTimestamp(),
      userAgent: navigator?.userAgent?.slice(0, 200) || '',
    });
  } catch {
    // Audit logging is best-effort; never block the user action
  }
};

// Fetch audit logs for the current user (scoped to their own data only)
export const getAuditLogs = async (userId, limitCount = 100) => {
  if (!userId) return [];
  try {
    const q = query(
      collection(db, 'auditLogs'),
      where('userId', '==', userId),
      orderBy('timestamp', 'desc'),
      limit(limitCount),
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch (error) {
    return [];
  }
};

// Admin-only: fetch all recent audit logs (server-side limited)
export const getAllAuditLogs = async (limitCount = 200) => {
  try {
    const q = query(
      collection(db, 'auditLogs'),
      orderBy('timestamp', 'desc'),
      limit(limitCount),
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch (error) {
    return [];
  }
};
